import React from 'react';
const PageWrap: React.FC<{ title: string; onBack: () => void; children: React.ReactNode }> = ({ title, onBack, children }) => (
  <div style={{ padding: 32, maxWidth: 800, margin: '0 auto' }}>
    <button onClick={onBack} style={{ background: 'none', border: 'none', color: '#8B6FFF', fontSize: 14, cursor: 'pointer', marginBottom: 20 }}>← Retour</button>
    <h1 style={{ fontSize: 28, fontWeight: 800, color: '#F8F7FF', marginBottom: 24 }}>{title}</h1>
    <div style={{ fontSize: 14, color: '#C8C8E8', lineHeight: 1.8 }}>{children}</div>
  </div>
);
export const PrivacyPage: React.FC<{ onBack: () => void }> = ({ onBack }) => (
  <PageWrap title="Privacy Policy" onBack={onBack}>
    <p>ContenuIA by Chanbé IA respects your privacy. We collect only the data necessary to provide our services: email, name, and generated content. Data is stored in Firebase (Google Cloud). We do not sell your data. Contact: contact@chanbeia.com</p>
    <p style={{ marginTop: 16 }}>Last updated: July 2026</p>
  </PageWrap>
);
export const TermsPage: React.FC<{ onBack: () => void }> = ({ onBack }) => (
  <PageWrap title="Terms of Service" onBack={onBack}>
    <p>By using ContenuIA, you agree to these terms. ContenuIA is provided "as is" by Chanbé IA (RS6776), M'Tsangamouji, Mayotte, France. Generated content is yours. We reserve the right to modify these terms. Contact: contact@chanbeia.com</p>
    <p style={{ marginTop: 16 }}>Last updated: July 2026</p>
  </PageWrap>
);
